"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setProcedures;

var _config = _interopRequireDefault(require("./config"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function validateRequiredFunction(procedureName, parameterName, parameterValue) {
  if (!parameterValue || typeof parameterValue !== 'function') {
    throw new Error("required param \"".concat(parameterName, "\" of ").concat(procedureName, " must be a function (was ").concat(_typeof(parameterValue), ")"));
  }
}

function validateOptionalFunction(procedureName, parameterName, parameterValue) {
  if (parameterValue && typeof parameterValue !== 'function') {
    throw new Error("param \"".concat(parameterName, "\" of ").concat(procedureName, " must be a function (was ").concat(_typeof(parameterValue), ")"));
  }
}

function setProcedureConfig(name, procedureConfiguration) {
  if (!procedureConfiguration || _typeof(procedureConfiguration) !== 'object') {
    throw new Error("procedure ".concat(name, " configuration must be an object (was ").concat(typeof opts === "undefined" ? "undefined" : _typeof(opts), ")"));
  }

  var getResultFromCache = procedureConfiguration.getResultFromCache,
      call = procedureConfiguration.call,
      buildUpdatedCache = procedureConfiguration.buildUpdatedCache,
      cacheModifier = procedureConfiguration.cacheModifier,
      modifyOtherCaches = procedureConfiguration.modifyOtherCaches;
  validateRequiredFunction(name, 'getResultFromCache', getResultFromCache);
  validateRequiredFunction(name, 'call', call);
  validateRequiredFunction(name, 'buildUpdatedCache', buildUpdatedCache);
  validateOptionalFunction(name, 'cacheModifier', cacheModifier);
  validateOptionalFunction(name, 'modifyOtherCaches', modifyOtherCaches);

  _config.default.setProcedure(name, {
    getResultFromCache: getResultFromCache,
    call: call,
    buildUpdatedCache: buildUpdatedCache,
    cacheModifier: cacheModifier,
    modifyOtherCaches: modifyOtherCaches
  });
}

function setProcedures(procedureConfigs) {
  var procedureConfigList = Object.entries(procedureConfigs);

  if (procedureConfigList.length <= 0) {
    throw new Error('setProcedures object should have at least one procedure defined');
  }

  procedureConfigList.forEach(function (_ref) {
    var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        configuration = _ref2[1];

    return setProcedureConfig(name, configuration);
  });
}